import Api from "./axios-instance";
import { isLocal } from "./helpers"

Api.defaults.withCredentials = true

export async function setSession(region, clientHint, returnSession, appUrl) {
  if (isLocal()){
    return {}
  }

  Api.defaults.withCredentials = true
  // clientHint can be null or 'homevisiting'
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (region) {
    headers['x-region'] = region
  }

  let baseUrlWithClient = "";
  let responseFromV1 = null

  if(appUrl){
    baseUrlWithClient = `${appUrl}${clientHint ? `?clientHint=${clientHint}`: ''}`
  }else{
    baseUrlWithClient = `${process.env.VUE_APP_V1DIR}${clientHint ? `?clientHint=${clientHint}`: ''}`
  }

  const responseSession = await getSession(clientHint, appUrl);

  if (responseSession.status !== 200 || !responseSession.clientIsServed) {

    responseFromV1 = await Api.get(encodeURI(baseUrlWithClient), { headers } );

    if (responseFromV1) {
      if (responseFromV1?.data?.cookies) {
        storeCookies(responseFromV1?.data?.cookies);
      }
    }

    if(returnSession){
      const responseSessionRetry = await getSessionRetry(clientHint, appUrl);
      return responseSessionRetry
    }
  }
  return returnSession ? responseSession : null
}

export async function getSession(clientHint, appUrl) {
  Api.defaults.withCredentials = true
  // clientHint can be null or 'homevisiting'
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const storedCookies = localStorage.getItem(window.location.host);

  let cookieValue;
  if (storedCookies) {
    cookieValue = parseCookie(`${window.location.host}-cookies`)
  }


  let responseSession
  try {
    if(appUrl){
      if (cookieValue) {
        headers.Authorization = `${cookieValue}`
        responseSession = await Api.get(encodeURI(`${appUrl}session`), { headers });
      } else {
        responseSession = await Api.get(encodeURI(`${appUrl}session`), { headers });
      }

    } else{
      if (cookieValue) {
        headers.Authorization = `${cookieValue}`
        responseSession = await Api.get(encodeURI(`${process.env.VUE_APP_V1DIR}session`), { headers });
      } else {
        responseSession = await Api.get(encodeURI(`${process.env.VUE_APP_V1DIR}session`), { headers });
      }
    }
  }
  catch (error) {
    responseSession = { data: [], status: 500, sessionId: null, clientIsServed: null, client: null }
  }

  // response from session endpoint is set into local storage
  localStorage.setItem(`${window.location.host}`, JSON.stringify(responseSession.data));

  const clientInUse = clientHint || 'directory'; // 'directory' is the bff default client
  const clientRaw = responseSession?.data?.filter( d => d.includes(clientInUse));
  const sessionIdRaw = responseSession?.data?.filter( d => d.toLocaleLowerCase().includes('sessionid'));

  const returnObject = {
    clientIsServed: !!clientRaw.length,
    client: clientRaw[0] ? clientRaw[0].split('=')[1] : null,
    sessionId: sessionIdRaw[0] ? sessionIdRaw[0].split('=')[1] : null,
    status: responseSession.status,
  }

  return returnObject
}

export async function getSessionRetry (clientHint, appUrl) {
  Api.defaults.withCredentials = true
  try{
    return await getSession(clientHint, appUrl)
  }
  catch(error){
    console.error('getSessionRetry: error:', error)
    return await getSession(clientHint, appUrl)
  }
}

// Store cookies function
function storeCookies(cookies) {
  const cookieObj = {
    expires: null // Initialize the expires property
  };

  cookies.forEach(cookie => {
    const parts = cookie.split(';');
    const keyValue = parts[0].split('=');

    // Check if keyValue has two parts
    if (keyValue.length === 2) {
      const key = keyValue[0]?.trim();
      const value = keyValue[1]?.trim();

      // Find the Expires part if it exists
      const expiresPart = parts.find(part => part.toLowerCase().trim().includes('expires='));

      // Assign the cookie value to the cookieObj
      cookieObj[key] = value;

      // If an expiresPart is found, assign it to cookieObj.expires
      if (expiresPart) {
        cookieObj.expires = expiresPart.split('=')[1]?.trim();
      }

    } else {
      console.warn(`Invalid cookie format: ${cookie}`);
    }
  });
  console.log("Cookies with Expires:", cookieObj);
  localStorage.setItem(`${window.location.host}-cookies`, JSON.stringify(cookieObj))
}

export function parseCookie (cookieName, returnObject) {
  const cookiesArray = JSON.parse(localStorage.getItem(cookieName));
  // Parse cookie array to extract desired values
  let token = cookiesArray?.token || '';
  let client = cookiesArray?.client || '';
  let sessionId = cookiesArray?.sessionid || '';
  let expires = cookiesArray?.expires || '';

  if(token === '' && cookiesArray?.length > 0){
    cookiesArray.forEach(cookie => {
        if(cookie.includes('token=')){
          token = cookie.split('=')[1]
        }
        if(cookie.includes('client=')){
          client = cookie.split('=')[1]
        }
        if(cookie.includes('sessionid=')){
          sessionId = cookie.split('=')[1]
        }
        if(cookie.includes('expires=')){
          expires = cookie.split('=')[1]
        }
      }
    )
  }

  if(returnObject){
    return { token, client, sessionId, expires }
  }
  
  if (Array.isArray(cookiesArray)) {
    return cookiesArray.join(';')
  }
  // Format these values into a single string
  const authString = `token=${token}; client=${client}; sessionId=${sessionId}; expires=${expires}`;

  return authString;

}

export function clearLocalStorageAndCookies(hrefName) {
  localStorage.removeItem(`${hrefName}-cookies`);
  localStorage.removeItem(`${hrefName}`);
}